import React, {FormEvent} from 'react';
import {Col, Form, FormControlProps} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface ACHCorporateNameFieldProps {
  handleInputChange: (e: any) => void;
}

class ACHCorporateNameFields extends React.Component<ACHCorporateNameFieldProps> {
  render() {
    return (
      <Col>
        <Form.Group style={{display: 'flex', alignItems: 'center'}}>
          <FontAwesomeIcon
            icon='id-card'
            className='fa-lg'
            style={{marginRight: '12px', maxWidth: '21px'}}
          />
          <Form.Control
            type='text'
            name='accountHolder'
            placeholder='Account Holder'
            aria-label='Account Holder'
            required={true}
            onChange={this.props.handleInputChange}
          />
        </Form.Group>
      </Col>
    );
  }
}

export default ACHCorporateNameFields;
